import React from "react";

export interface TextSkeletonLoaderProps {
  colorA?: string;
  colorB?: string;
  colorC?: string;
}

export default function TextSkeletonLoader(props?: TextSkeletonLoaderProps): React.JSX.Element {
  const A = props?.colorA || "#22aaff";
  const B = props?.colorB || "#22cccc";
  const C = props?.colorC || "#aa77ff";

  return (
    <svg width="100%" height="180">
      <defs>
        <linearGradient id="gradient" x1="0%" y1="0%" x2="100%" y2="0%">
          <stop offset="0%" stopColor={A}>
            <animate attributeName="stop-color" values={`${A}; ${B}; ${C}; ${A}`} dur="5s" repeatCount="indefinite" />
          </stop>
          <stop offset="50%" stopColor={B}>
            <animate attributeName="stop-color" values={`${B}; ${C}; ${A}; ${B}`} dur="5s" repeatCount="indefinite" />
          </stop>
          <stop offset="100%" stopColor={C}>
            <animate attributeName="stop-color" values={`${C}; ${A}; ${B}; ${C}`} dur="5s" repeatCount="indefinite" />
          </stop>
        </linearGradient>
      </defs>
      <rect x="10%" y="20" width="80%" height="20" fill="url(#gradient)">
        <animate attributeName="width" values="80%; 40%; 80%" dur="8s" repeatCount="indefinite" />
        <animate attributeName="x" values="10%; 30%; 10%" dur="8s" repeatCount="indefinite" />
      </rect>
      <rect x="10%" y="50" width="75%" height="20" fill="url(#gradient)">
        <animate attributeName="width" values="75%; 50%; 75%" dur="7s" repeatCount="indefinite" />
        <animate attributeName="x" values="10%; 25%; 10%" dur="7s" repeatCount="indefinite" />
      </rect>
      <rect x="10%" y="80" width="78%" height="20" fill="url(#gradient)">
        <animate attributeName="width" values="78%; 60%; 78%" dur="9.5s" repeatCount="indefinite" />
        <animate attributeName="x" values="10%; 20%; 10%" dur="9.5s" repeatCount="indefinite" />
      </rect>
      <rect x="10%" y="110" width="79%" height="20" fill="url(#gradient)">
        <animate attributeName="width" values="79%; 45%; 79%" dur="6s" repeatCount="indefinite" />
        <animate attributeName="x" values="10%; 27%; 10%" dur="6s" repeatCount="indefinite" />
      </rect>
      <rect x="10%" y="140" width="60%" height="20" fill="url(#gradient)">
        <animate attributeName="width" values="60%; 30%; 60%" dur="10.5s" repeatCount="indefinite" />
        <animate attributeName="x" values="10%; 35%; 10%" dur="10.5s" repeatCount="indefinite" />
      </rect>
    </svg>
  );
}